import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css']
})
export class CheckBoxComponent extends ControlBaseDirective implements AfterViewChecked {
  @Input() control: AbstractControl = {} as FormControl;
  @ViewChild('checkbox') public checkbox!: ElementRef;
  @Input() toolTipText?: string;
  @Input() disableCheckbox?: boolean;

  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    super(roleService, applicationContext);
    this.idField = '';
  }
  ngAfterViewChecked(): void {
    super.ngAfterContentInit();
  }

  assignToControl(evt: any): void {
    if (this.control) {
      const newValue = this.control.value;
      if (newValue && typeof newValue !== "boolean") {
        newValue[this.idField] = evt.target.checked;
        this.control.setValue(newValue);
      }
    }
  }
}
